import { Button } from '@fluentui/react-components';
import { ArrowBidirectionalUpDown20Regular, ArrowSortDown20Filled, ArrowSortUp20Filled } from '@fluentui/react-icons';
import { CellData, HeaderContext, SortDirection } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { FolderPermissionResponse } from '../../../../api/types.gen';
import { PermissionTableFeatures } from './permissionTableFeatures';

interface IHeaderCellProps<TValue extends CellData> {
  headerContext: HeaderContext<PermissionTableFeatures, FolderPermissionResponse, TValue>;
}

export function HeaderCell<TValue extends CellData>({ headerContext }: IHeaderCellProps<TValue>) {
  const { t } = useTranslation('', { keyPrefix: 'permissions' });
  const { column } = headerContext;
  const sortDirection = column.getIsSorted();

  let sortLabel = t('unsortedLabel');
  if (sortDirection === 'asc') {
    sortLabel = t('sortAscLabel');
  }

  if (sortDirection === 'desc') {
    sortLabel = t('sortDescLabel');
  }

  return (
    <Button
      onClick={column.getToggleSortingHandler()}
      appearance="transparent"
      style={{
        whiteSpace: 'nowrap',
        padding: 0,
        justifyContent: 'space-between',
        gap: 4,
      }}
      aria-label={sortLabel}
    >
      {t(headerContext.column.id)}
      <SortIcon sortDirection={sortDirection} />
    </Button>
  );
}

interface ISortProps {
  sortDirection: false | SortDirection;
}

function SortIcon({ sortDirection }: ISortProps) {
  if (sortDirection === 'asc') {
    return <ArrowSortUp20Filled />;
  }

  if (sortDirection === 'desc') {
    return <ArrowSortDown20Filled />;
  }

  return <ArrowBidirectionalUpDown20Regular />;
}
